import { SortOrder } from '@/enums';
import { axiosClient } from '@/hooks';
import { IGender } from '@/interfaces';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface PaginatedResponse<T> {
  items: T[];
  count: number;
  pages: number;
  previousPage: number | null;
  page: number;
  nextPage: number | null;
  limit: number;
}

export const fetchGenders = createAsyncThunk(
  'genders/fetchGenders',
  async (
    {
      page = 1,
      limit = 10,
      orderBy,
      sortOrder,
      search
    }: {
      page?: number;
      limit?: number;
      orderBy?: string;
      sortOrder?: SortOrder;
      search?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosClient.get(`/genders`, {
        params: {
          page,
          limit,
          ...(orderBy && { orderBy }),
          ...(sortOrder && { sortOrder }),
          ...(search && { search })
        }
      });
      return response.data.data as PaginatedResponse<IGender>;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch genders');
    }
  }
);
